<template>
  <div class="attendance-scheduling-rank">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />

    <div class="attendance-scheduling-rank-sub">
      <div style="margin-right: 10px;">班组名称</div>
      <el-input v-model="formData.groupName" size="small" style="width: 280px" disabled/>
    </div>
    <div class="attendance-scheduling-rank-sub">
      <div style="margin-right: 10px;">班次说明</div>
      <div class="attendance-scheduling-rank-info">
        <div class="classes-list">
          <div class="classes-item" v-for="item in classesList">
            <div class="classes-item-box" :style="{background: item.backgroundColor, border: item.border}"></div>
            <div class="classes-item-text">{{item.classesName}}</div>
            <div class="classes-item-text" v-if="item.checkInTime && item.checkOutTime">{{item.checkInTime}}——{{item.checkOutTime}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="attendance-scheduling-rank-sub">
      <div style="margin-right: 10px;">日期选择</div>
      <el-date-picker v-model="schedulingMonth" type="month" format='yyyy-MM' value-format="yyyy-MM" size="small" style="width: 280px" placeholder="排班日期"></el-date-picker>
    </div>
    <div class="attendance-scheduling-rank-table">
      <div class="attendance-scheduling-rank-table-head">
        <div class="attendance-scheduling-rank-table-item-name">姓名</div>
        <div class="attendance-scheduling-rank-table-item-day" v-for="day in dayInSchedulingMonthArr">
          <div class="attendance-scheduling-rank-table-item-day-week-tip">{{day.weekDay}}</div>
          <div class="attendance-scheduling-rank-table-item-day-week-main">
            <el-popover placement="top-start" title="按日期一键排班" width="200" trigger="click">
              <el-select v-model="day.daySelectCode" size="mini" placeholder="请选择" @change="daySelectCodeChange">
                <el-option v-for="item in classesSelectList" :key="item.classesCode" :label="item.classesName" :value="item.classesCode"></el-option>
              </el-select>
              <el-button plain slot="reference">{{day.day}}</el-button>
            </el-popover>
          </div>
        </div>
      </div>
      <div style="flex: 1;overflow-y: auto;">
        <div class="attendance-scheduling-rank-table-info" v-for="personInfo in schedulingTableData">
          <div class="attendance-scheduling-rank-table-item-name">
            <el-popover placement="top-start" title="按人员一键排班" width="200" trigger="click">
              <el-select v-model="personInfo.personSelectCode" size="mini" placeholder="请选择" @change="personSelectCodeChange">
                <el-option v-for="item in classesSelectList" :key="item.classesCode" :label="item.classesName" :value="item.classesCode"></el-option>
              </el-select>
              <el-button plain slot="reference"><span>{{personInfo.person.name}}</span><img src="../../../assets/basic/drop_down.png" class="attendance-scheduling-rank-table-item-img" alt=""></el-button>
            </el-popover>
          </div>
          <div class="attendance-scheduling-rank-table-item-day" v-for="schedules in personInfo.schedules">
            <!--          <div>{{schedules.day}}</div>-->
            <el-select v-model="schedules.selectCode" placeholder="请选择" :class="schedules.className" @change="schedulesItemchange">
              <el-option v-for="item in classesSelectList" :key="item.classesCode" :label="item.classesName" :value="item.classesCode"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="form-btn-box">
      <button-confirm @confirm="confirm" />
      <button-cancel @cancel="cancel" />
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import {bus} from '../../../utils/bus'
  import {api} from '../../api/AttendancePoint'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'attendance-scheduling-rank',
    data () {
      return {
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '排班管理'
        }],
        mainTitle: '班组排班',
        subheading: '',

        classesList: [],
        classesSelectList: [],
        schedulingMonth: '',
        dayInSchedulingMonthArr: [],
        formData: {
          groupCode: '',
          classesCodes: ''
        },
        schedulingTableData: []
      }
    },
    created () {
      this.getGroupClassesRelationByCode()
    },
    methods: {
      // 查询
      getGroupClassesRelationByCode () {
        this.$axios.get(`${api.getGroupClassesRelationByCode}/${this.$route.params.id}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let classesList = [], classesSelectList = [], classesBackgroundList = ['#C4D8FF', '#FED195', '#C593FF', '#FF9A8D', '#FFFFFF']
              data.classesList.map((v, i) => {
                v.backgroundColor = classesBackgroundList[i]
                classesList.push(v)
                classesSelectList.push(v)
              })
              classesSelectList.unshift({classesCode: '-1',classesName: '休息', backgroundColor: '#FFFFFF', border: '1px solid #AAAAAA'})
              classesList.push({classesCode: '-1',classesName: '休息', backgroundColor: '#FFFFFF', border: '1px solid #AAAAAA'})
              this.classesList = classesList
              this.classesSelectList = classesSelectList
              this.formData = data
              this.getCurrentMonthInfo()
            }
          })
          .catch(errorHandler('查询失败'))
      },

      // 查询当月信息
      getCurrentMonthInfo () {
        let nowDate = new Date()
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        this.schedulingMonth = `${year}-${month}`
        this.getAllDayInSchedulingMonth()
      },

      // 获取某月的天数及每日星期
      getAllDayInSchedulingMonth () {
        let year = this.schedulingMonth.split('-')[0]
        let month = this.schedulingMonth.split('-')[1]
        let dayNum = (new Date(year, month, 0)).getDate()
        let presentDate = new Date(`${this.schedulingMonth}-01`)
        let today = presentDate.getDay() !== 0 ? presentDate.getDay() : 7
        let weekArr = ['日', '一', '二', '三', '四', '五', '六'], dayInSchedulingMonthArr = []
        for (let i = 1; i <= dayNum; i++) {
          let weekIndex = (i + today - 1) % 7
          let obj = {
            daySelectCode: '',
            day: i,
            weekDay: weekArr[weekIndex]
          }
          dayInSchedulingMonthArr.push(obj)
        }
        this.dayInSchedulingMonthArr = dayInSchedulingMonthArr
      },

      // 查询排班信息
      getAttendanceScheduleList () {
        this.$axios.post(`${api.getAttendanceScheduleList}`, {
          groupCode: this.formData.groupCode,
          startTime: `${this.schedulingMonth}-01`
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              let schedulingTableData = data.table
              schedulingTableData.map(v => {
                v.schedules.map(item => {
                  item.isModifyState = false
                  item.selectCode = item.classesCode
                  item.defaultSelectCode = item.classesCode
                  this.classesSelectList.map((classItem, classIndex) => {
                    if (item.selectCode === classItem.classesCode) {
                      item.className = `attendance-scheduling-rank-table-item-select-${classIndex}`
                    }
                  })
                })
              })
              this.schedulingTableData = data.table
            }
          })
          .catch(errorHandler('查询失败'))
      },

      schedulesItemchange (e) {
        this.schedulingTableData.map(v => {
          v.schedules.map(info => {
            if (info.selectCode !== info.defaultSelectCode) {
              info.isModifyState = true
            }
            this.classesSelectList.map((classItem, classIndex) => {
              if (info.selectCode === classItem.classesCode) {
                info.className = `attendance-scheduling-rank-table-item-select-${classIndex}`
              }
            })
          })
        })
      },

      // 人员一键排班
      personSelectCodeChange () {
        this.schedulingTableData.map(v => {
          if (v.personSelectCode) {
            v.schedules.map(info => {
              info.selectCode = v.personSelectCode
              if (info.selectCode !== info.defaultSelectCode) {
                info.isModifyState = true
              }
              this.classesSelectList.map((classItem, classIndex) => {
                if (info.selectCode === classItem.classesCode) {
                  info.className = `attendance-scheduling-rank-table-item-select-${classIndex}`
                }
              })
            })
            v.personSelectCode = ''
          }
        })
      },

      // 日期一键排班
      daySelectCodeChange () {
        this.dayInSchedulingMonthArr.map(day => {
          let index = day.day - 1
          if (day.daySelectCode) {
            this.schedulingTableData.map(v => {
              v.schedules.map((info, infoIndex) => {
                if (infoIndex === index) {
                  info.selectCode = day.daySelectCode
                  if (info.selectCode !== info.defaultSelectCode) {
                    info.isModifyState = true
                  }
                  this.classesSelectList.map((classItem, classIndex) => {
                    if (info.selectCode === classItem.classesCode) {
                      info.className = `attendance-scheduling-rank-table-item-select-${classIndex}`
                    }
                  })
                }
              })
            })
          }
          day.daySelectCode = ''
        })

        console.log(this.dayInSchedulingMonthArr)
        console.log(this.schedulingTableData)
      },

      toManagementPage () {
        this.$router.push({
          name: 'attendance-scheduling-manage'
        })
      },

      // 添加
      confirm () {
        if (!this.schedulingMonth) {
          nError('请选择日期并进行排班')
          return false
        }
        let reqData = []
        this.schedulingTableData.map(v => {
          v.schedules.map(item => {
            if (item.isModifyState) {
              item.personCode = v.person.code
              item.classesCode = item.selectCode
              reqData.push(item)
            }
          })
        })
        this.$axios.post(api.saveAttendanceSchedule, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('操作成功')
              this.toManagementPage()
            }
          })
          .catch(errorHandler('操作失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    },
    watch: {
      schedulingMonth (v) {
        if (this.schedulingMonth) {
          this.getAllDayInSchedulingMonth()
          this.getAttendanceScheduleList()
        } else {
          nError('请选择日期')
        }
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 600px;
    padding: 0 140px;
    margin: 40px auto;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
.attendance-scheduling-rank {
  font-family: Source Han Sans SC;
  .attendance-scheduling-rank-sub {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 24px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #333333;
    text-align: left;
    margin: 20px 0 10px 0;
  }
  .attendance-scheduling-rank-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .attendance-scheduling-rank-table {
    text-align: center;
    width: 100%;
    height: 486px;
    margin-top: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 8px rgba(92, 92, 92, 0.16);
    border-radius: 7px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    ::-webkit-scrollbar {
      width: 2px;
      height: 1px;
    }
    .el-select, .el-select>.el-input {
      height: 100%;
    }
    .el-input--suffix .el-input__inner {
      width: 100%;
      height: 100%;
      padding: 0;
      font-size: 12px;
      border: 0;
      border-radius: 0;
      text-align: center;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .el-input__suffix {
      display: none;
    }
    .attendance-scheduling-rank-table-head, .attendance-scheduling-rank-table-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      .attendance-scheduling-rank-table-item-name {
        width: 100px;
        height: 48px;
        font-size: 16px;
        font-weight: 400;
        line-height: 48px;
        color: #333333;
        border-right: 1px solid #eeeeee;
        .el-button {
          width: 98px;
          height: 46px;
          border: 0;
          span {
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              flex: 1;
            }
          }
        }
        .attendance-scheduling-rank-table-item-img {
          width: 15px;
          height: 15px;
        }
      }
      .attendance-scheduling-rank-table-item-day {
        width: 28px;
        padding: 5px 0;
        flex: 1;
        border-right: 1px solid #eeeeee;
        .attendance-scheduling-rank-table-item-day-week-tip {
          font-size: 12px;
          color: #CCCCCC;
          margin-bottom: 7px;
        }
        .attendance-scheduling-rank-table-item-day-week-main {
          width: 25px;
          height: 25px;
          font-size: 16px;
          cursor: pointer;
          border-radius: 50%;
          margin: 0 auto;
          .el-button {
            width: 25px;
            height: 25px;
            border: 0;
            padding: 0;
            border-radius: 50%;
          }
          .el-button.is-plain:focus, .el-button.is-plain:hover {
            color: #FFFFFF;
            background: #1362FF;
          }
          :hover {
            .el-button {
              color: #FFFFFF;
              background: #1362FF;
            }
          }
        }
      }
      .attendance-scheduling-rank-table-item-day:last-child {
        border-left: 0;
      }
    }
    .attendance-scheduling-rank-table-info {
      .attendance-scheduling-rank-table-item-day {
        padding: 0;
        height: 48px;
      }
      .attendance-scheduling-rank-table-item-select-1 {
        .el-input--suffix .el-input__inner {
          background: #C4D8FF;
          color: #FFFFFF;
        }
      }
      .attendance-scheduling-rank-table-item-select-2 {
        .el-input--suffix .el-input__inner {
          background: #FED195;
          color: #FFFFFF;
        }
      }
      .attendance-scheduling-rank-table-item-select-3 {
        .el-input--suffix .el-input__inner {
          background: #C593FF;
          color: #FFFFFF;
        }
      }
      .attendance-scheduling-rank-table-item-select-4 {
        .el-input--suffix .el-input__inner {
          background: #FF9A8D;
          color: #FFFFFF;
        }
      }
    }
  }
  .el-switch {
    height: 30px;
  }
  .classes-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .classes-item {
      width: 150px;
      height: 78px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      margin-right: 20px;
      .classes-item-box {
        width: 38px;
        height: 38px;
      }
      .classes-item-text {
        color: #333333;
        font-size: 12px;
        height: 20px;
        line-height: 20px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceScheduling/AttendanceSchedulingRank.vue